<template>
  <div class="c-title">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: "CTitle",
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>


<style scoped lang="scss">
.c-title {
  font-size: 28px;
  font-weight: bold;
  line-height: 28px;
  color: #333333;
  padding-left: 16px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    width: 6px;
    height: 24px;
    border-radius: 20px;
    background: #22A0FF;
    transform: translateY(-50%);
  }
}
</style>
